import React, { Component } from 'react'
import { Link } from 'react-router-dom'
import { NextDisabledContext } from '../../context/nextDisabled'

class Controls extends Component {

  parseContext() {
    let currentContext = this.context
    if (!currentContext) {
      return currentContext = {
        nextDisabled: false,
        backDisabled: false
      }
    }
    if (typeof this.context === 'boolean') {
      return currentContext = {
        nextDisabled: this.context,
        backDisabled: false
      }
    }
    return currentContext
  }

  renderBackButton() {
    let buttonClassName = 'button back'
    let imageClassName = 'no-visibility'
    let currentContext = this.parseContext()
    if (this.props.buttonClassName) {
      buttonClassName += ' ' + this.props.buttonClassName
    }
    if (currentContext.backDisabled) {
      imageClassName = 'loading-image'
    }
    switch (typeof this.props.back) {
      case 'string':
        return (
          <Link id="controls_back_button" to={this.props.back}>
            <div className="button back">BACK</div>
          </Link>
        )
      case 'function':
        return (
          <button
            id="controls_back_button"
            disabled={currentContext.backDisabled || currentContext.nextDisabled}
            onClick={this.props.back}
            className={buttonClassName}
            data-atid={`${this.props.dataAtId}_back`}
          >
            <img className={imageClassName} src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/00a4582b-ede1-4e2d-be2e-83a2ad5e3d63.gif" width="20px" />
            {currentContext.backDisabled ? "Loading" : "BACK"}
          </button>
        )
      default: return null
    }
  }

  renderNextButton() {
    let buttonClassName = 'button next'
    let imageClassName = 'no-visibility'
    let currentContext = this.parseContext()
    if (this.props.buttonClassName) {
      buttonClassName += ' ' + this.props.buttonClassName
    }
    if (currentContext.nextDisabled) {
      imageClassName = 'loading-image'
    }
    switch (typeof this.props.next) {
      case 'string':
        return (
          <Link id="controls_next_button" to={this.props.next}>
            <div className="button next">{this.props.nextLabel || "NEXT"}</div>
          </Link>
        )
      case 'function':
        return (
          <div>
            <button
              id="controls_next_button"
              aria-labelledby="controls_next_button"
              aria-describedby={this.props.ariaDescribedby ? this.props.ariaDescribedby : ""}
              disabled={currentContext.nextDisabled || currentContext.backDisabled}
              onClick={this.props.next}
              className={buttonClassName}
              data-atid={`${this.props.dataAtId}_next`}
            >
              <img className={imageClassName} src="https://image.my.newtopia.com/lib/fe9113727c60037c75/m/1/00a4582b-ede1-4e2d-be2e-83a2ad5e3d63.gif" width="20px" />
              {currentContext.nextDisabled ? "Loading" : this.props.nextLabel || "NEXT"}
            </button>
          </div>
        )
      default: return null
    }
  }

  render() {
    this.className = "controls"
    if (this.props.className) {
      this.className += ` ${this.props.className}`
    }
    return (
      <div className={this.className}>
        <div className="buttons">
          {this.renderBackButton()}
          {this.renderNextButton()}
        </div>
      </div>
    )
  }
}
Controls.contextType = NextDisabledContext

export default Controls